module.exports = __webpack_public_path__ + "img/default-speicalist-avatar.66e1df77.png";